import { DataSourceFunction } from '../../component-data-source.service';
import { of } from 'rxjs';
import { EducationalPathItem } from '../../../../models/educational-path/EducationalPathItem.model';

export const educationalPathItems: DataSourceFunction = {
  name: 'educational-path-items',
  execute: () => of({ 
    items: [
      new EducationalPathItem(1, 'guid1', 'Module 1', 'modules', true, null, '2024-01-01', '2024-12-31'),
      new EducationalPathItem(2, 'guid2', 'Goal 1', 'goal', true, null, '2024-01-01', '2024-12-31'),
      new EducationalPathItem(3, 'guid3', 'Subtype 1', 'subtype', true, null, '2024-01-01', '2024-12-31'),
      new EducationalPathItem(4, 'guid4', 'Module 2', 'modules', true, null, '2024-01-01', '2024-12-31'),
      new EducationalPathItem(5, 'guid5', 'Goal 2', 'goal', true, null, '2024-01-01', '2024-12-31'),
      new EducationalPathItem(6, 'guid6', 'Subtype 2', 'subtype', true, null, '2024-01-01', '2024-12-31')
    ],
    totalCount: 6
  })
}; 